import { render, staticRenderFns } from "./MobileBottomNav.vue?vue&type=template&id=60699636&scoped=true&"
import script from "./MobileBottomNav.vue?vue&type=script&lang=js&"
export * from "./MobileBottomNav.vue?vue&type=script&lang=js&"
import style0 from "./MobileBottomNav.vue?vue&type=style&index=0&id=60699636&scoped=true&lang=css&"
import style1 from "./MobileBottomNav.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60699636",
  null
  
)

export default component.exports